import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './en.json';
import skTranslations from './sk.json';
import huTranslations from './hu.json';

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      sk: {
        translation: skTranslations
      },
      hu: {
        translation: huTranslations
      }
    },
    lng: 'sk', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

export default i18n; 